<script setup lang="ts">

import {useHttpStore} from "~/composables/stores/http.store";
import {useAdminHttpStore} from "~/composables/stores/admin/adminHttp.store";
import {useAdminDataStore} from "~/composables/stores/admin/adminData.store";
import LanguageSwitcher from "~/components/common/languageSwitcher.vue";

let http = useHttpStore()
let adminHttp = useAdminHttpStore()
let adminData = useAdminDataStore()
let router = useRouter()
const localePath = useLocalePath()
const {locale, t} = useI18n()
const toast = useToast()

let {isLoading} = useLoadingIndicator({})

let c = await useAsyncData('getDomainGroupAdmin', async () => {
  const domainGroupObj = await http.getDomainGroup()
  http.domainGroupObj = domainGroupObj
  return domainGroupObj
}, {deep: true})
// let {data} = await useAsyncData('AllSizesAdmin', () => {
//   return adminHttp.getAllAdminData()
// }, {deep: true})

const links = [
  {label: 'Dashboard', to: localePath('/admin/dashboard'), icon: 'i-lucide-line-chart'},
  {label: 'Bevétel - Gyors', to: localePath('/admin/input'), icon: 'i-mdi-input'},
  {label: 'Bevétel', to: localePath('/admin/inputSlow'), icon: 'i-mdi-input'},
  {label: 'Termékek', to: localePath('/admin/stock'), icon: 'i-octicon-database-16'},
  {label: 'Termékek old', to: localePath('/admin/stockOld'), icon: 'i-octicon-database-16'},
  {label: 'Eladások', to: localePath('/admin/sell'), icon: 'i-ph-currency-circle-dollar-bold'},
  {label: 'Visszavétel', to: localePath('/admin/returns'), icon: 'i-material-symbols-light-keyboard-return'},
  {label: 'Megrendelések', to: localePath('/admin/orders'), icon: 'i-fluent-vehicle-truck-bag-24-filled'},
  {label: 'Fájlok', to: localePath('/admin/files'), icon: 'i-material-symbols-light-folder-copy'},
  {label: 'Törlés', to: localePath('/admin/delete'), icon: 'i-healthicons-burn-outline'},
  {label: 'Fordito', to: localePath('/admin/translate'), icon: 'i-ic-twotone-g-translate'},
]

</script>

<template>
  <div>
    <UNavigationMenu class="border-b border-gray-200 dark:border-gray-800 w-full justify-center" :items="links"/>
    <LanguageSwitcher></LanguageSwitcher>
    <div class="m-6">
      <div v-show="isLoading">
        <AdminLoading></AdminLoading>
      </div>
      <div v-show="!isLoading">
        <slot>
        </slot>
      </div>

    </div>
  </div>

</template>

<style scoped>

</style>
